import { ReactNode } from "react";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";

import { default as BootsrapTooltip } from "react-bootstrap/Tooltip";

import { Placement } from "react-bootstrap/esm/types";
import { CaretUpFill } from "react-bootstrap-icons";

import styles from "./tooltip.module.scss";
import classNames from "classnames";
interface TooltipProps {
  title: string | ReactNode;
  placement?: Placement;
  className?: string;
  children?: ReactNode;
  color?: "dark" | "light";
}
export const Tooltip: React.FC<TooltipProps> = ({
  children,
  title,
  className,
  color = "light",
  placement = "bottom",
}) => {
  const tooltipClass = classNames(styles.tooltip, [
    className,
    color === "dark" && styles.dark,
  ]);
  return (
    <OverlayTrigger
      placement={placement}
      overlay={
        <BootsrapTooltip placement={placement} className={tooltipClass}>
          {title}
        </BootsrapTooltip>
      }
    >
      {({ ref, ...triggerHandler }) => (
        <div {...triggerHandler} ref={ref} className={styles.overlay_body}>
          {children}
        </div>
      )}
    </OverlayTrigger>
  );
};
